
import { t } from "@lingui/macro";
import { FilterType } from "../models/local/Types";

export class Tran {
  static filterType(type: FilterType): string {
    switch (type) {
      case 'docs':
        return t`Docs`;
      case 'photos':
        return t`Photos`;
      case 'text':
        return t`Text`;
      case 'voice':
        return t`Voice`;
      case 'video':
        return t`Screen Recording`;
      default:
        return '';
    }
  }
}